<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div class="flex">
        <el-button type="primary" size="small" @click="add"
          >新建接龙活动</el-button
        >
        <div class="flex item-center ml20">
          <div class="pointer" @click="openDialogShare">
            <span class="delete-icon hmicon icon-xitong"></span>
            基础设置
          </div>
        </div>
      </div>
      <div>
        <el-input
          clearable
          style="width:300px"
          v-model.trim="queryGoodsValue"
          :placeholder="placeholderGoodsType"
          size="small"
          class="ipt mr10"
        >
          <el-select
            slot="prepend"
            size="small"
            style="width:100px"
            @change="selectQuerySnType"
            v-model="queryGoodsType"
          >
            <el-option label="商品名称" value="wxshopSpuName"></el-option>
            <el-option label="商品货号" value="goodsSn"></el-option>
            <el-option label="商品条码" value="specBarcode"></el-option>
          </el-select>
        </el-input>
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="keyword"
          placeholder="请输入活动名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-select
          clearable
          class="mr10"
          size="small"
          v-model="activityState"
          placeholder="请选择活动状态"
        >
          <el-option label="进行中" value="running"></el-option>
          <el-option label="未开始" value="notStarted"></el-option>
          <el-option label="已结束" value="end"></el-option>
          <el-option label="已隐藏" value="hide"></el-option>
          <el-option label="未启用" value="notEnabled"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button type="info" size="small" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="list"
        style="width: 100%"
        ref="table"
        stripe
        border
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="活动名称"
          prop="gameName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="活动时间"
          prop="gameStartTime"
        >
          <template slot-scope="scope">
            {{ scope.row.gameStartTime }}至{{ scope.row.gameEndTime }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="创建时间"
          width="170"
          prop="createTime"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="活动状态"
          prop="activityState"
          width="80"
        >
          <template slot-scope="scope">
            <span class="success" v-show="scope.row.activityState === 'running'"
              >进行中</span
            >
            <span
              class="danger"
              v-show="scope.row.activityState === 'notStarted'"
              >未开始</span
            >
            <span class="success" v-show="scope.row.activityState === 'end'"
              >已结束</span
            >
            <span class="danger" v-show="scope.row.activityState === 'hide'"
              >已隐藏</span
            >
            <span
              class="danger"
              v-show="scope.row.activityState === 'notEnabled'"
              >未启用</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="上/下线"
          width="80"
        >
          <template slot-scope="scope">
            <div
              :class="scope.row.enabledState === 'yes' ? 'success' : 'danger'"
            >
              {{ scope.row.enabledState === "yes" ? "上线" : "下线" }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="teams"
          label="操作"
          width="350"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <!-- <el-select
                class="mr10"
                size="small"
                filterable
                @change="changeTeam(scope.row)"
                v-model="scope.row.team"
                placeholder="团管理"
              >
                <el-option
                  :label="v.val"
                  :value="v.val"
                  :key="i"
                  v-for="(v, i) in teams"
                ></el-option>
              </el-select> -->
              <el-dropdown trigger="click" size="small" @command="changeTeam">
                <el-button
                  size="small"
                  class=" primary mr10"
                  type="text"
                  @click="clickTeam(scope.row)"
                >
                  团管理
                  <i
                    class="el-icon-arrow-down el-icon--right"
                    style="margin-left:-5px"
                  ></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="修改团">修改团</el-dropdown-item>
                  <el-dropdown-item command="删除团">删除团</el-dropdown-item>
                  <el-dropdown-item command="复制团">复制团</el-dropdown-item>
                  <el-dropdown-item
                    command="隐藏团"
                    v-if="scope.row.activityState !== 'hide'"
                    >隐藏团</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="上线"
                    v-if="scope.row.enabledState === 'no'"
                    >上线</el-dropdown-item
                  >
                  <el-dropdown-item
                    command="下线"
                    v-if="scope.row.enabledState === 'yes'"
                    >下线</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-button size="small" type="text" @click="operation(scope.row)"
                >订单管理
              </el-button> -->
              <el-button size="small" type="text" @click="detail(scope.row)"
                >查看订单</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="gameshopList(scope.row)"
                >活动商品</el-button
              >
              <el-tooltip class="item" content="活动码" placement="top">
                <button
                  class="pointer mr10 no-bg"
                  @click="productQrcode(scope.row.gameId)"
                >
                  <span class="hmicon icon-erweima blue"></span>
                </button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <!-- 活动商品 -->
    <el-dialog
      :close-on-click-modal="false"
      title=""
      width="1300px"
      :visible.sync="dialogVisible"
    >
      <div class="table">
        <el-button
          style="float: left"
          @click="addGoods"
          type="primary"
          size="small"
          >添加商品
        </el-button>
        <el-table
          :data="shopList"
          style="width: 100%"
          ref="tixian"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="商品货号"
            prop="goodsSn"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="商品名称"
            prop="wxshopSpuName"
            width="150"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="商品规格"
            prop="specIdGroupName"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="单人限购"
            prop="singleLimit"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="活动库存"
            prop="totalStockSum"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="零售价"
            prop="wxshopPrice"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="接龙价"
            prop="activityPrice"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="showShopNum"
            label="已售数量"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="商品状态"
            prop="goodsStates"
            width="80"
          >
            <template slot-scope="scope">
              <span class="success" v-show="scope.row.goodsStates === 'running'"
                >售卖中</span
              >
              <span class="danger" v-show="scope.row.goodsStates === 'sellOut'"
                >已售罄</span
              >
              <span class="success" v-show="scope.row.goodsStates === 'del'"
                >已移除</span
              >
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="delFlag"
            label="操作"
            width="150"
          >
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button
                  v-if="scope.row.delFlag == 0"
                  size="small"
                  type="text"
                  @click="changeShop(scope.$index, scope.row, 'del')"
                  >移除</el-button
                >
                <el-button
                  v-if="scope.row.delFlag == 1"
                  size="small"
                  type="text"
                  @click="changeShop(scope.$index, scope.row, 'restore')"
                  >复原</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!--订单详情  -->
    <el-dialog
      title="订单详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleOffline"
      width="1200px"
    >
      <el-scrollbar :vertical="false" wrap-style="height: 500px;">
        <div class="dialog-body">
          <div class="mb20">
            <div class="table">
              <el-table
                stripe
                border
                :data="orderDetailList"
                style="width: 100%"
                id="table"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  type="index"
                  label="序号"
                  width="50"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberName"
                  label="会员姓名"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberMobile"
                  label="会员手机号"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="receiptSn"
                  label="订单号"
                >
                  <template slot-scope="scope">
                    <el-link @click="detailNum(scope.row)">{{
                      scope.row.receiptSn
                    }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="actuallyPrice"
                  label="订单实付金额"
                >
                  <template slot-scope="scope">
                    ¥{{ scope.row.actuallyPrice || "0.00" }}
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  prop="joinTime"
                  align="center"
                  label="下单时间"
                ></el-table-column>
                <el-table-column
                  label="查看报名详情"
                  width="150"
                  header-align="center"
                  align="center"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <div class="pointer mr10" @click="toDetails(scope.row)">
                        <span class="hmicon icon-chakan blue"></span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </el-dialog>
    <!-- 微信二维码 -->
    <el-dialog
      title="请用微信扫一扫"
      :visible.sync="qrcodeDialogVisible"
      :modal="false"
      width="250px"
    >
      <div class="qrcode-wrapper">
        <img style="width:100%" :src="activityCode" alt="二维码" />
      </div>
    </el-dialog>
    <!-- 修改新增的商品 -->
    <el-dialog
      title="添加商品"
      :close-on-click-modal="false"
      :visible.sync="addShopDialogVisible"
      width="1200px"
    >
      <el-scrollbar :vertical="false" wrap-style="height: 300px;">
        <div class="dialog-body">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="130px"
          >
            <el-table
              :data="ruleForm.jielongGoodsRuleModelList"
              row-key="wxshopSkuId"
              border
              stripe
              style="width: 100%"
            >
              <el-table-column type="index" label="序号" width="50">
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsSn"
                label="商品货号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="wxshopSpuName"
                label="商品名称"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="specIdGroupName"
                label="商品规格"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="singleLimit"
                label="单人限购"
                width="122"
              >
                <template slot="header">
                  <el-popover
                    placement="top-start"
                    title="提示"
                    width="200"
                    trigger="hover"
                    content="单人限购为必填"
                  >
                    <div slot="reference">单人限购</div>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-input
                    maxlength="30"
                    @mousewheel.prevent.native
                    style="width: 80px"
                    v-model.trim="scope.row.singleLimit"
                    size="small"
                    @input="filterGt0OrFixed0('singleLimit', scope.$index)"
                    clearable
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="totalStockSum"
                label="活动库存"
                width="150"
              >
                <template slot="header">
                  <el-popover
                    placement="top-start"
                    title="提示"
                    width="200"
                    trigger="hover"
                    content="活动库存为必填"
                  >
                    <div slot="reference">活动库存</div>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-input
                    maxlength="30"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.totalStockSum"
                    size="small"
                    @input="filterGt0OrFixed0('totalStockSum', scope.$index)"
                    clearable
                    placeholder="活动库存"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="wxshopPrice"
                label="零售价"
                style="width: 80px"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="activityPrice"
                label="接龙价"
              >
                <template slot="header">
                  <el-popover
                    placement="top-start"
                    title="提示"
                    width="200"
                    trigger="hover"
                    content="接龙价为必填"
                  >
                    <div slot="reference">接龙价</div>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-input
                    maxlength="30"
                    @mousewheel.prevent.native
                    style="width: 80px"
                    v-model.trim="scope.row.activityPrice"
                    size="small"
                    @input="filterGt0OrFixed2('activityPrice', scope.$index)"
                    clearable
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="virtualExchangeNum"
                label="已售数量"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="操作"
                width="70px"
              >
                <template slot-scope="scope">
                  <div class="minus-wrapper flex flex-center">
                    <span
                      class="hmicon icon-jianhao pointer"
                      @click="deleteGoodChild(scope.$index, scope.row)"
                    ></span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
          <div class="btn-wrapper mb20 flex flex-center">
            <el-button size="small" type="primary" @click="saveBtn('ruleForm')"
              >确 定</el-button
            >
            <el-button size="small" @click="closeBtn">取 消</el-button>
          </div>
        </div>
      </el-scrollbar>
    </el-dialog>
    <el-dialog
      title="基础设置"
      :visible.sync="dialogShare"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleFormShare"
        :rules="ruleFormSharerules"
        ref="ruleFormShare"
        label-width="200px"
        class="demo-ruleForm"
      >
        <div>
          <el-form-item label="列表分享图:" prop="shareImg">
            <el-upload
              class="upload flex"
              ref="eluploadMainPic"
              :limit="1"
              drag
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :onSuccess="uploadMainPicSucc"
              :beforeUpload="beforeUpload"
              :onProgress="uploading"
              :show-file-list="uploadShow"
              v-if="!ruleFormShare.shareImg"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片拖到此处，或
                <em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                <span class="mr">
                  上传图片注意：
                  <br />1.建议图片尺寸为500x400像素的png图
                  <br />2.图片格式：只能上传jpg/png文件
                </span>
              </div>
            </el-upload>
            <div class="priview" v-if="ruleFormShare.shareImg">
              <el-image
                class="image"
                :src="ruleFormShare.shareImg"
                alt="主图"
                :preview-src-list="[ruleFormShare.shareImg]"
                />
              <div class="opreat-wrapper flex item-center flex-center" v-if="ruleFormShare.shareImg">
                <el-button type="text" @click="handleRemove">删除</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item class="mb10" label="列表分享文案:" prop="shareTitle">
            <el-input
              clearable
              style="width: 250px"
              type="textarea"
              v-model.trim="ruleFormShare.shareTitle"
              placeholder="请输入列表文案"
              size="small"
              class="ipt mr10"
            ></el-input>
          </el-form-item>
          <el-form-item label="官方团长头像:" prop="headerImg">
            <el-upload
              class="upload flex"
              ref="eluploadMainPic"
              :limit="1"
              drag
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :onSuccess="uploadMainPicSucc2"
              :beforeUpload="beforeUpload"
              :onProgress="uploading"
              :show-file-list="uploadShow"
              v-if="!ruleFormShare.headerImg"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片拖到此处，或
                <em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                <span class="mr">
                  上传图片注意：
                  <br />1.建议图片尺寸为500x400像素的png图
                  <br />2.图片格式：只能上传jpg/png文件
                </span>
              </div>
            </el-upload>
            <div class="priview priview2" v-if="ruleFormShare.headerImg">
              <el-image
                class="image"
                :src="ruleFormShare.headerImg"
                alt="主图"
                :preview-src-list="[ruleFormShare.headerImg]"
                />
              <div class="opreat-wrapper flex item-center flex-center" v-if="ruleFormShare.headerImg">
                <el-button type="text" @click="handleRemove2">删除</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item class="mb10" label="官方团长名称:" prop="headerName">
            <el-input
              clearable
              style="width: 250px"
              v-model.trim="ruleFormShare.headerName"
              placeholder="请输入官方团长名称(最多10个字)"
              size="small"
              class="ipt mr10"
              maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item class="mb10" label="首页分享使用此配置:" prop="HomeState">
            <el-switch
              v-model="ruleFormShare.HomeState"
              active-text="开启"
              inactive-text="关闭"
              active-color="#13ce66"
              active-value="open"
              inactive-value="close"
            ></el-switch>
            <div>设置后首页的分享将不再使用首页的分享卡片，使用该配置的卡片</div>
          </el-form-item>
          <el-form-item class="mb10" label="店员分享锁定下单门店:" prop="guiderShareState">
            <el-switch
              v-model="ruleFormShare.guiderShareState"
              active-text="开启"
              inactive-text="关闭"
              active-color="#13ce66"
              active-value="open"
              inactive-value="close"
            ></el-switch>
            <div>开启后店员分享接龙给好友时，可设置锁定用户的下单门店，开启此功能需在职员管理处维护店员的手机号</div>
          </el-form-item>
          <el-form-item class="mb10" label="是否开启基础设置:" prop="state">
            <el-switch
              v-model="ruleFormShare.state"
              active-text="开启"
              inactive-text="关闭"
              active-color="#13ce66"
              active-value="open"
              inactive-value="close"
            ></el-switch>
          </el-form-item>
          <el-form-item class="mb10" label="是否开启按顺序显示商品图:" prop="is_share_sort_open">
            <el-switch
              v-model="ruleFormShare.is_share_sort_open"
              active-text="开启"
              inactive-text="关闭"
              active-color="#13ce66"
              active-value="open"
              inactive-value="close"
            ></el-switch>
          </el-form-item>
        </div>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitruleFormShare('ruleFormShare')"
            >保存</el-button
          >
          <el-button size="small" @click="dialogShare = false"
            >取消</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      title="报名详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleDetails"
    >
    <el-table
        stripe
        border
        class="mb20"
        ref="brandTable"
        :data="detailsList"
        style="width: 100%"
        id="table"
        size="small"
        :show-header="false"
      >
        <el-table-column
          header-align="center"
          align="right"
          prop="columnName"
          show-overflow-tooltip
          label="v.columnName"
          width="200"
        >
        <template slot-scope="scope">
          {{scope.row.columnName}}:
        </template>
        
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="inputValue"
          show-overflow-tooltip
          label="v.columnName"
        >
          <template slot-scope="scope">
            <el-image
              style="width:100px; height:100px"
              :src="scope.row.inputValue"
              :preview-src-list="[scope.row.inputValue]"
              v-if="scope.row.columnType === 'picture'"
            >
            </el-image>
             <span v-else>{{scope.row.inputValue}}</span>
      　　</template>
        </el-table-column>

    </el-table>
    </el-dialog>
    <hm-filter-m-s-goods
      type="microShop"
      :visible="dialogVisibleAdd"
      :radio="isRadio"
      @saveGoods="saveGoods"
      @setLink="setLink"
      @close="dialogVisibleAdd = false"
    >
    </hm-filter-m-s-goods>
  </hm-content>
</template>
<script>
import HmFilterMSGoods from "@/components/HmFilterMSGoods";
import { mapGetters } from "vuex";
import myUpload from "vue-image-crop-upload";
import {getLoginUser, getUserName} from "@/utils/auth";
// import { getLoginUser } from "@/utils/auth";
import { setCookie, getCookie, arrayUnique2 } from "@/utils/utils";
import HmDetailsOrder from "@/components/HmDetailsOrder";
export default {
  components: {
    HmDetailsOrder,
    myUpload,
    HmFilterMSGoods
  },
  computed: mapGetters(["myActivityList", "allGameTypeList"]),
  data() {
    const patterndRuleFunc = (rule, val, callback) => {
      let falg = false;
      this.ruleForm.jielongGoodsRuleModelList.forEach(v => {
        if (
          v.totalStockSum === "" ||
          v.singleLimit === "" ||
          v.activityPrice === ""
        ) {
          falg = true;
        }
        if (falg) {
          return callback(new Error("请输入必填项"));
        }
      });
      callback();
    };
    return {
      index: 0,
      row: null,
      addShopDialogVisible: false,
      gameId: "",
      dialogVisibleAdd: false,
      queryGoodsValue: "",
      placeholderSnType: "请输入订单号",
      placeholderGoodsType: "请输入商品名称",
      placeholderMemberType: "请输入会员名称",
      placeholderSourcType: "请输入会员名称",
      queryGoodsType: "wxshopSpuName",
      qrcodeDialogVisible: false,
      activityCode: "",
      teamsVal: "",
      team: null,
      teams: [
        { val: "修改团", num: "1" },
        { val: "删除团", num: "2" },
        { val: "复制团", num: "3" },
        { val: "隐藏团", num: "4" },
        { val: "上线", num: "5" },
        { val: "下线", num: "6" }
      ],
      gameType: "",
      keyword: "",
      ruleForm: {
        jielongGoodsRuleModelList: []
      },
      rules: {
        jielongGoodsRuleModelList: [
          {
            required: true,
            message: "请设置规则！",
            trigger: "blur"
          },
          {
            required: true,
            validator: patterndRuleFunc,
            trigger: "blur"
          }
        ]
      },
      orderDetailList: [],
      dialogVisibleOffline: false,
      dialogVisible: false,
      searchCondition: {},
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      currentPageDetail: 1,
      pageSizeDetail: 10,
      totalDetail: 0,
      activityState: "",
      shopList: [],
      isRadio: false,
      ruleFormShare: {
        shareImg:"",
        shareTitle: "", 
        state: "close",
        headerImg: "",
        headerName: "",
        HomeState: "close",
        guiderShareState: "close",
        is_share_sort_open: 'close'
      },
      ruleFormSharerules:{},
      uploadShow: true,
      dialogShare: false,
      storeCode: "",
      dialogVisibleDetails: false,
      detailsList: [],
    };
  },
  created() {},
  mounted() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    this.queryList();
  },
  methods: {
    // 新建接龙活动
    add() {
      this.$router.push({
        name: "JieLong",
        query: {
          type: "add"
        }
      });
    },
    // 头部重置按钮
    reset() {
      this.activityState = "";
      this.gameType = "";
      this.keyword = "";
    },
    // 头部搜索按钮
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    // 移除商品 --- 复原商品
    async changeShop(index, row, type) {
      console.log(type);
      let params = {
        operationType: type,
        id: row.id
      };
      await this.$store.dispatch("changeGoodsAddlList", params).then(res => {
        if (res.code == 0) {
          this.getGameshopList();
          this.$message({
            message: "修改成功",
            type: "success"
          });
          // setTimeout(() => { }, 500);
        }
      });
    },
    filterGt0OrFixed2(prop, i) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.jielongGoodsRuleModelList[i][
        prop
      ] = this.ruleForm.jielongGoodsRuleModelList[i][prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.ruleForm.jielongGoodsRuleModelList[i][
        prop
      ] = this.ruleForm.jielongGoodsRuleModelList[i][prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.ruleForm.jielongGoodsRuleModelList[i][
        prop
      ] = this.ruleForm.jielongGoodsRuleModelList[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm.jielongGoodsRuleModelList[i][
        prop
      ] = this.ruleForm.jielongGoodsRuleModelList[i][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.ruleForm.jielongGoodsRuleModelList[i][prop].indexOf(".") < 0 &&
        this.ruleForm.jielongGoodsRuleModelList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleForm.jielongGoodsRuleModelList[i][prop] = parseFloat(
          this.ruleForm.jielongGoodsRuleModelList[i][prop]
        );
      }
    },
    filterGt0OrFixed0(prop, i) {
      if (prop !== "activityPrice" && prop !== "virtualExchangeNum") {
        this.ruleForm.jielongGoodsRuleModelList[i][
          prop
        ] = this.ruleForm.jielongGoodsRuleModelList[i][prop].replace(
          /^(0+)/,
          ""
        ); //过滤0开头
      }

      this.ruleForm.jielongGoodsRuleModelList[i][
        prop
      ] = this.ruleForm.jielongGoodsRuleModelList[i][prop].replace(
        /[^\d]+/g,
        ""
      );
      this.ruleForm.jielongGoodsRuleModelList[i][
        prop
      ] = this.ruleForm.jielongGoodsRuleModelList[i][prop].replace(
        /\.{2,}/g,
        ""
      ); //两个连续的"."仅保留第一个"."
    },
    // 删除新增商品
    deleteGoodChild(index, row) {
      this.ruleForm.jielongGoodsRuleModelList.splice(index, 1);
    },
    // 新增商品 --- 确定
    saveBtn(formName) {
      console.log("保存修改");
      this.$refs[formName].validate(valid => {
        console.log("valid--", valid);
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          params.gameId = this.gameId;
          // 修改
          this.$store.dispatch("saveJielongGoods", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              setTimeout(() => {
                this.addShopDialogVisible = false;
              }, 500);
            }
          });
        } else {
          console.log(33);
          return false;
        }
      });
    },
    // 新增商品 --- 取消
    closeBtn() {
      this.addShopDialogVisible = false;
      console.log("取消修改");
    },
    clickTeam(row) {
      this.row = row;
    },
    changeTeam(team) {
      let gameId = this.row.gameId;
      this.teamsVal = team;
      if (this.teamsVal == "修改团") {
        console.log(1, "修改");
        this.$router.push({
          name: "JieLong",
          query: { gameId, changeTeam: true }
        });
      }
      if (this.teamsVal == "删除团") {
        console.log(2, "删除");
        this.operationjieLong(gameId, "del", "您确定删除吗");
      }
      if (this.teamsVal == "复制团") {
        console.log(3, "复制");
        this.$router.push({
          name: "JieLong",
          query: { gameId, copyJieLong: false }
        });
      }
      if (this.teamsVal == "隐藏团") {
        console.log(4, "隐藏");
        this.operationjieLong(gameId, "hide", "您确定隐藏吗");
      }
      if (this.teamsVal == "上线") {
        console.log(5, "上线");
        this.operationjieLong(gameId, "online", "请确定上线吗");
      }
      if (this.teamsVal == "下线") {
        console.log(5, "下线");
        this.operationjieLong(gameId, "offline", "您确定下线吗");
      }
    },
    selectQuerySnType(val) {
      if (val === "wxshopSpuName") {
        this.placeholderGoodsType = "请输入商品名称";
      } else if (val === "goodsSn") {
        this.placeholderGoodsType = "请输入商品货号";
      } else if (val === "specBarcode") {
        this.placeholderGoodsType = "请输入商品条码";
      }
    },
    async operationjieLong(id, type, txt) {
      let params = {
        gameId: id,
        operationType: type
      };
      this.$confirm(txt, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("operationjieLong", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    // 获取接龙活动表格
    async queryList() {
      let params = {
        queryKey: this.queryGoodsType,
        queryValue: this.queryGoodsValue,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        activityState: this.activityState,
        gameName: this.keyword
      };
      this.setParamsCookie();
      let res = await this.$store.dispatch("findJieLongList", params);
      if (res.result) {
        this.total = res.result.total;
        this.list = res.result.records;
        this.list.forEach(item => {
          item.teams = this.teams;
          item.team = this.team;
        });
      }
    },
    // 头部搜索
    setParamsCookie() {
      let searchCondition = {
        dateFlag: this.dateFlag,
        activityState: this.activityState,
        gameType: this.gameType,
        keyword: this.keyword
      };
      setCookie({
        key: "myActivityParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    // 二维码弹框
    async productQrcode(gameId) {
      // const { storeCode } = getLoginUser();
      const { storeCode } = getLoginUser();
      let userName = getUserName();
      let params = {
        path: `gameId=${gameId}`,
        storeCode: storeCode,
        createBy: userName,
        shareFunction: "营销中心-接龙活动列表",
        shareFrom: "bg"
      }
      const url = await this.$store.dispatch("shareDataSaveV2", params);

      const { result } = await this.$store.dispatch("createCouponQrcode", {
        path: `activity/jieLong/infor?saveUUID=${url.result}`
      });
      this.qrcodeDialogVisible = true;
      this.activityCode = result;
    },
    resetForm() {
      setTimeout(() => {
        // this.$refs.ruleForm.resetFields();
        // this.ruleForm.id = "";
      }, 0);
    },
    //  订单详情--- 查看订单
    async detail(row) {
      console.log("查看订单", row);
      this.row = row;
      let params = {
        gameId: row.gameId
      };
      let res = await this.$store.dispatch("getOrderDetailList", params);
      if (res.result && res.result.records) {
        this.orderDetailList = res.result.records;
      }
      this.dialogVisibleOffline = true;
    },
    del(row) {
      this.$confirm(" 是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        row.operationType = "del";
        this.$store.dispatch("editStoreOfflineDrawRule", row).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    async getGameshopList() {
      this.gameId = this.row.gameId;
      let params = {
        gameId: this.gameId
      };
      let res = await this.$store.dispatch("getGoodsDetailList", params);
      if (res.result) {
        this.shopList = res.result;
        if (this.shopList) {
          this.shopList.forEach(item => {
            item.showShopNum = item.totalStockSum - item.remainStockSum;
          });
        }
      }
    },
    // 活动商品 已经添加的活动商品列表
    gameshopList(row) {
      this.row = row;
      this.dialogVisible = true;
      this.getGameshopList();
    },
    // 新增活动商品接口
    async getGoodsAddlList() {
      let params = {
        gameId: this.gameId,
        jielongGoodsRuleModelList: {}
      };
      let res = await this.$store.dispatch("getGoodsAddlList", params);
      if (res.result) {
        console.log("gameshopList--res", res);
        this.shopList = res.result;
      }
    },
    // 活动商品
    addGoods() {
      this.dialogVisibleAdd = true;
    },
    setLink(row) {
      this.dialogVisibleAdd = false;
      this.isRadio = false;
    },
    // 活动商品列表
    saveGoods(data) {
      if (data.length > 0) {
        this.dialogVisible = false;
        this.ruleForm.jielongGoodsRuleModelList = [];
        this.ruleForm.jielongGoodsRuleModelList.push(...data);
        this.ruleForm.jielongGoodsRuleModelList = arrayUnique2(
          this.ruleForm.jielongGoodsRuleModelList,
          "wxshopSkuId"
        );
        this.addShopDialogVisible = true;
        this.dialogVisibleAdd = false;
      } else {
        this.$message({
          message: "请选择商品",
          type: "warning"
        });
      }
    },
    // 跳转到订单列表页面
    operation(row) {
      this.$router.push({
        name: "OrderListNew",
        query: {
          gameId: row.gameId
        }
      });
    },
    // 跳转到订单列表页面
    detailNum(row) {
      console.log("row", row);
      this.$router.push({
        name: "OrderListNew",
        query: {
          receiptSn: row.receiptSn
        }
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    getParamsCookie() {
      const prams = getCookie({ key: "myActivityParams", type: "session" });
      if (prams) {
        this.dateFlag = prams.dateFlag;
        this.activityState = prams.activityState;
        this.keyword = prams.keyword;
        this.gameType = prams.gameType;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    // 正在上传
    uploading() {
      this.uploadShow = true;
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 1M!",
          type: "warning"
        });
      }
      return (extension || extension2 || extension3 || extension4) && limitSize;
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.ruleFormShare.shareImg = jsonData.result;
        this.uploadShow = false;
      }
    },
    uploadMainPicSucc2(jsonData) {
      if (jsonData.code === 0) {
        this.ruleFormShare.headerImg = jsonData.result;
        this.uploadShow = false;
      }
    },
    // 移除上传文件
    handleRemove() {
      this.ruleFormShare.shareImg = "";
    },
    handleRemove2() {
      this.ruleFormShare.headerImg = "";
    },
    openDialogShare(){
      this.queryStoreConfigAll();
      this.dialogShare = true;
    },
    async queryStoreConfigAll(){      
      const { result } = await this.$store.dispatch("queryStoreConfigAll", {
        storeCode: this.storeCode,
        code:"jielongShare",
      });
      console.log("result:",result);
      if(result.value){
        // this.ruleFormShare = JSON.parse(result.value);
      }else{
        this.addStoreConfigAll();
      }
    },
    async addStoreConfigAll(){
      let value = JSON.stringify(this.ruleFormShare);
      const { result } = await this.$store.dispatch("addStoreConfigAll", {
        storeCode: this.storeCode,
        code:"jielongShare",
        name:"新增接龙分享设置",
        value: value,
      });
      console.log("result:",result);
    },
    async editStoreConfigAll(){
      let value = JSON.stringify(this.ruleFormShare);
      const { result } = await this.$store.dispatch("editStoreConfigAll", {
        storeCode: this.storeCode,
        code:"jielongShare",
        name:"编辑接龙分享设置",
        value: value,
      });
      this.$message({
        type: "success",
        message: "设置成功"
      });
      this.queryStoreConfigAll();
      this.dialogShare = false;
    },
    // 提交
    submitruleFormShare(formName){
      this.editStoreConfigAll();      
    },
    async toDetails(row) {
      const { result } = await this.$store.dispatch(
        "queryJielongDynamicForm",
        {
          receiptSn: row.receiptSn,
          invokeId: this.row.gameId,
        }
      );
      this.detailsList = result;
      this.dialogVisibleDetails = true;
    },
  }
};
</script>
<style lang="scss" scoped>
.title {
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}

.priview {
  position: relative;
  width: 250px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .image {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priview2{
  width: 150px;
  height: 150px;
}
.btn {
  border: 1px solid #ddd;
  text-align: center;
  padding: 10px;
  width: 80px;
  height: 80px;
  cursor: pointer;
  .add-wrapper {
    width: 30px;
    height: 30px;
    line-height: 30px;
    background: #e50065;
    color: #fff;
    text-align: center;
    border-radius: 50%;
    margin: 0 auto;
    span {
      font-size: 12px;
    }
    cursor: pointer;
    .hmicon {
      font-size: 14px;
      margin-right: 0 !important;
    }
  }
}

.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 130px;
    height: 130px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
</style>
